// @ts-nocheck
/* eslint-disable */
export const appHome24Icon = {
    data: `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5 9.42857L12 4L19 9.42857V20H5V9.42857Z" stroke="currentColor" stroke-width="2"/><rect opacity="0.5" x="9" y="12" width="6" height="8" fill="currentColor"/></svg>`,
    name: 'home-24' as const
};